




import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class WechatLogin extends Vue {
  @Prop() private appId!: string
  @Prop() private redirectUri!: string
  @Prop() private wechatState!: string

  /**
   * 二维码登录
   */
  private showQRCode () {
    const obj = window.WxLogin({
      self_redirect: false, // 默认在 top window 跳转
      id: 'login_container',
      appid: this.appId,
      scope: 'snsapi_login',
      redirect_uri: encodeURIComponent(this.redirectUri),
      state: this.wechatState,
      style: 'black',
      href: ''
    })
  }

  mounted () {
    this.showQRCode()
  }
}
